"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableQueryCw20ContractInfo = exports.ObservableQueryCw20ContactInfoInner = void 0;
const chain_query_1 = require("../chain-query");
const mobx_1 = require("mobx");
const contract_query_1 = require("./contract-query");
class ObservableQueryCw20ContactInfoInner extends contract_query_1.ObservableCosmwasmContractChainQuery {
    constructor(kvStore, chainId, chainGetter, contractAddress) {
        super(kvStore, chainId, chainGetter, contractAddress, { token_info: {} });
        this.contractAddress = contractAddress;
    }
    get tokenInfo() {
        if (!this.response || !this.response.data) {
            return undefined;
        }
        return this.response.data;
    }
}
__decorate([
    mobx_1.computed
], ObservableQueryCw20ContactInfoInner.prototype, "tokenInfo", null);
exports.ObservableQueryCw20ContactInfoInner = ObservableQueryCw20ContactInfoInner;
class ObservableQueryCw20ContractInfo extends chain_query_1.ObservableChainQueryMap {
    constructor(kvStore, chainId, chainGetter) {
        super(kvStore, chainId, chainGetter, (contractAddress) => {
            return new ObservableQueryCw20ContactInfoInner(this.kvStore, this.chainId, this.chainGetter, contractAddress);
        });
        this.kvStore = kvStore;
        this.chainId = chainId;
        this.chainGetter = chainGetter;
    }
    getQueryContract(contractAddress) {
        return this.get(contractAddress);
    }
}
exports.ObservableQueryCw20ContractInfo = ObservableQueryCw20ContractInfo;
//# sourceMappingURL=cw20-contract-info.js.map